var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowUp = function SvgArrowUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "arrow-up_svg__svg-icon",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "arrow-up_svg__arrow-up"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13 19V7.83l4.88 4.88c.39.39 1.03.39 1.42 0a.996.996 0 0 0 0-1.41l-6.59-6.59a.996.996 0 0 0-1.41 0l-6.6 6.58a.996.996 0 1 0 1.41 1.41L11 7.83V19c0 .55.45 1 1 1s1-.45 1-1",
    className: "arrow-up_svg__vector"
  }))));
};
export { SvgArrowUp as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9Im5vbmUiIHZpZXdCb3g9IjAgMCAyNCAyNCIgY2xhc3M9InN2Zy1pY29uIiByb2xlPSJpbWciPjx0aXRsZT5BcnJvdyBVcDwvdGl0bGU+PGcgY2xhc3M9ImFycm93LXVwIj48cGF0aCBmaWxsPSJjdXJyZW50Q29sb3IiIGQ9Ik0xMyAxOVY3LjgzbDQuODggNC44OGMuMzkuMzkgMS4wMy4zOSAxLjQyIDBhLjk5Ni45OTYgMCAwIDAgMC0xLjQxbC02LjU5LTYuNTlhLjk5Ni45OTYgMCAwIDAtMS40MSAwbC02LjYgNi41OGEuOTk2Ljk5NiAwIDEgMCAxLjQxIDEuNDFMMTEgNy44M1YxOWMwIC41NS40NSAxIDEgMXMxLS40NSAxLTFaIiBjbGFzcz0idmVjdG9yIi8+PC9nPjwvc3ZnPg==";